import { Controller } from '@hotwired/stimulus';
import { MapList } from '../../components/modern/maps/list';

const MAP_URL = 'https://maps.googleapis.com/maps/api/js?v=3.exp&key=';

// Connects to data-controller="maps--list"
export default class extends Controller {
  static values = {
    locations: Array,
    googleKey: String
  }

  connect() {
    if (document.googleMapLib) {
      this.initializeMapList();
    } else {
      this.loadGoogleMaps();
    }
  }

  loadGoogleMaps() {
    const script = document.createElement('script');
    script.src = `${MAP_URL}${this.googleKeyValue}&libraries=places`;
    script.async = true;
    script.onload = () => {
      document.googleMapLib = true;
      this.initializeMapList();
    };
    document.head.appendChild(script);
  }

  initializeMapList() {
    // MapList and TextSearchingEngine are defined in list.js
    new MapList(this.element, this.locationsValue);
  }
}
